import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import FeaturedChannels from "./components/FeaturedChannels";
import LatestUploads from "./components/LatestUploads";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const stats = [
  { value: "120万+", label: "在线视频内容" },
  { value: "8", label: "视频分类频道" },
  { value: "每日更新", label: "海量新片上线" },
  { value: "高清流畅", label: "多端观看体验" },
];

export default function Home() {
  useDocumentMeta(
    "西瓜视频 - 高清在线视频播放与丰富视频内容平台",
    "西瓜视频为用户提供丰富多样的视频内容，包括短视频、影视剧、综艺节目等，满足您随时在线观看视频和内容浏览的需求。",
    "西瓜视频,在线视频,高清视频,短视频,影视剧,综艺节目,视频平台,视频播放"
  );

  return (
    <div className="w-full">
      <h1 className="sr-only">西瓜视频 - 高清在线视频播放与丰富视频内容平台</h1>

      <HeroCarousel />

      <CategoryQuickEntry />

      <FeaturedChannels />

      <LatestUploads />

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="rounded-lg bg-accent-50 border border-accent-100 px-5 md:px-10 py-8 md:py-12">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-3">
              关于西瓜视频
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              丰富内容，随时观看
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              西瓜视频是一个以在线视频播放为核心的内容平台，汇集短视频、影视剧、综艺节目、动漫、纪录片等多样视频内容。
              我们致力于为每一位用户提供高清流畅的观看体验与便捷的内容发现方式，让好内容随时触手可及。
            </p>
            <Link
              to="/about-us"
              className="inline-flex items-center gap-1 mt-5 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
            {stats.map((item) => (
              <div key={item.label} className="bg-background-50 rounded-lg px-4 py-4 border border-accent-100">
                <p className="text-xl md:text-2xl font-bold font-heading text-primary-600">
                  {item.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}